import { useEffect } from "react";
import { AutoDialerV2 } from "@td/auto_dialer";
import { ATTENDEE_STATUSES } from "../../constants";

export const useNotification = ({ memberCallData }) => {
  useEffect(() => {
    if (memberCallData.currentStatusCode === ATTENDEE_STATUSES.JOINED) {
      AutoDialerV2.playNotification();
    }
  }, [memberCallData.currentStatusCode]);
};
